var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatReactioni = function SvgChatReactioni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M7.501 12.01a4.5 4.5 0 0 1 4.487-4.48.4.4 0 0 1 .407.4.4.4 0 0 1-.407.414 3.674 3.674 0 0 0-3.67 3.664 3.68 3.68 0 0 0 3.67 3.672 3.68 3.68 0 0 0 3.666-3.672.4.4 0 0 1 .412-.4.4.4 0 0 1 .405.4 4.5 4.5 0 0 1-4.483 4.492 4.5 4.5 0 0 1-4.487-4.49m1.664.793a.42.42 0 0 1 .055-.367.4.4 0 0 1 .328-.16h4.865a.39.39 0 0 1 .327.16.41.41 0 0 1 .073.367 2.97 2.97 0 0 1-2.825 2.063 2.965 2.965 0 0 1-2.823-2.068zm2.823 1.242a2.17 2.17 0 0 0 1.785-.953h-3.569a2.15 2.15 0 0 0 1.784.953m2.018-2.781v-1.27h-1.27a.4.4 0 0 1-.406-.41.4.4 0 0 1 .406-.406h1.27V7.912a.406.406 0 0 1 .407-.414.406.406 0 0 1 .412.414v1.266h1.266a.4.4 0 0 1 .41.406.4.4 0 0 1-.41.41h-1.266v1.27a.4.4 0 0 1-.412.406.4.4 0 0 1-.412-.406z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatReactioni);
export default ForwardRef;